export default "__VITE_ASSET__Du6$7OaC__";